import React, { useState } from 'react'
import { useNavigate, Link } from 'react-router-dom'
import { supabase } from '../lib/supabase'
import { IconSchool } from '../components/Icons'

export default function AccesEcole() {
  const navigate = useNavigate()
  const [code, setCode] = useState('')
  const [loading, setLoading] = useState(false)
  const [erreur, setErreur] = useState('')

  const connecter = async (e) => {
    e.preventDefault()
    setErreur('')
    setLoading(true)
    const codeNorm = code.toUpperCase().trim()

    // RPC SECURITY DEFINER : validation côté serveur
    const { data, error } = await supabase
      .rpc('ecole_get_enfant', { p_code: codeNorm })

    setLoading(false)

    if (error || !data || data.length === 0) {
      setErreur('Code incorrect. Vérifiez le code transmis par les parents.')
      return
    }

    const enfant = data[0]
    sessionStorage.setItem('ecole_enfant_id', enfant.id)
    sessionStorage.setItem('ecole_pseudonyme', enfant.pseudonyme)
    sessionStorage.setItem('ecole_code', codeNorm)
    navigate(`/ecole/${enfant.id}`)
  }

  return (
    <div style={containerStyle}>
      <div style={cardStyle}>
        <div style={{ textAlign: 'center', marginBottom: 28 }}>
          <div style={iconStyle}>
            <IconSchool size={28} color="#fff" />
          </div>
          <h1 style={titreStyle}>Accès École</h1>
          <p style={{ color: '#64748b', fontSize: 14, marginTop: 6 }}>
            Saisissez le code fourni par les parents
          </p>
        </div>

        <form onSubmit={connecter} style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
          <div>
            <label style={labelStyle}>Code d'accès</label>
            <input
              type="text"
              required
              value={code}
              onChange={e => { setCode(e.target.value.toUpperCase()); setErreur('') }}
              style={inputStyle}
              placeholder="Ex: ABC123"
              maxLength={8}
              autoCapitalize="characters"
              autoComplete="off"
            />
          </div>
          {erreur && (
            <div style={{ background: '#fee2e2', color: '#dc2626', borderRadius: 8, padding: '10px 14px', fontSize: 13, fontWeight: 600 }}>
              {erreur}
            </div>
          )}
          <button type="submit" disabled={loading} style={btnStyle}>
            {loading ? 'Vérification...' : 'Accéder au tableau'}
          </button>
        </form>

        <div style={{ marginTop: 20, padding: '12px 16px', background: '#f0fdf4', borderRadius: 10, border: '1px solid #bbf7d0' }}>
          <p style={{ fontSize: 12, color: '#166534', lineHeight: 1.6, margin: 0 }}>
            Ce code vous a été transmis par la famille. Vous ne verrez que les défis scolaires.
          </p>
        </div>

        <p style={{ textAlign: 'center', marginTop: 20, color: '#64748b', fontSize: 13 }}>
          Vous êtes parent ?{' '}
          <Link to="/connexion" style={{ color: '#2563eb', fontWeight: 700 }}>
            Connexion parents
          </Link>
        </p>
      </div>
    </div>
  )
}

const containerStyle = {
  minHeight: '100vh', background: 'linear-gradient(135deg, #1e3a5f 0%, #2563eb 100%)',
  display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 20,
  fontFamily: "'Inter', sans-serif"
}
const cardStyle = {
  background: '#fff', borderRadius: 16, padding: '36px 32px',
  maxWidth: 440, width: '100%', boxShadow: '0 20px 60px rgba(0,0,0,0.15)'
}
const iconStyle = {
  width: 60, height: 60, borderRadius: '50%',
  background: 'linear-gradient(135deg, #1e3a5f, #2563eb)',
  display: 'flex', alignItems: 'center', justifyContent: 'center',
  margin: '0 auto 16px'
}
const titreStyle = {
  fontFamily: "'Playfair Display', serif", fontSize: 26,
  fontWeight: 900, color: '#1e293b', margin: 0
}
const labelStyle = { display: 'block', fontSize: 13, fontWeight: 600, color: '#374151', marginBottom: 6 }
const inputStyle = {
  width: '100%', padding: '14px', borderRadius: 10,
  border: '2px solid #e2e8f0', fontSize: 22, fontWeight: 800,
  textAlign: 'center', letterSpacing: 6, outline: 'none',
  fontFamily: "'Inter', sans-serif", color: '#1e293b', boxSizing: 'border-box'
}
const btnStyle = {
  width: '100%', padding: '12px', borderRadius: 10, border: 'none',
  background: 'linear-gradient(135deg, #1e3a5f, #2563eb)',
  color: '#fff', fontSize: 15, fontWeight: 700, cursor: 'pointer',
  fontFamily: "'Inter', sans-serif"
}
